module.exports = __webpack_public_path__ + "img/shimian.43de1e0d.png";